import { SubscriberStore } from '../stores/subscriber';
import { cleanCompaniesStore, cleanOperatorsStore, getNetworksSelect } from './';
import dayjs from 'dayjs';
import { appConfig } from '../settings';
import { IBodyItemResponse, IGetApiResponse, IRequestAPIBody, apiManager } from '../REST';
import { IDeviceAttribute, IDeviceAttributeAPI, IItemAPINew, IPostItem, SubscriberType } from '../interfaces';
import { ISubscriberAPI, ISubscriberInfo } from '../interfaces';
import { IMapField, globalHexId, mapApi2UiField, mapUi2ApiField } from '../instruments';
import { tI } from '../translate';

export function getSubscriberEditRelationSelect(): void {
    getNetworksSelect();
}

export async function patchSubscriber(id: string, fields: IMapField): Promise<IPostItem> {
    const SubscriberStoreInstance = SubscriberStore.getInstance();

    const apiBody: IRequestAPIBody = {
        ...mapUi2ApiField(fields),
    };
    const { resp, isError } = await apiManager.getApi('PATCH_SUBSCRIBER_V2', { id: id }, apiBody);
    const response = resp as IBodyItemResponse;
    const { subscriber } = resp as IItemAPINew;

    if (!isError && subscriber) {
        SubscriberStoreInstance.setInfo({ id: subscriber.id, ...mapApi2UiField(subscriber) });
    }
    return { isError, resp: response };
}

export function cleanSubscriberStore(): void {
    cleanCompaniesStore();
    cleanOperatorsStore();
    const StoreInstance = SubscriberStore.getInstance();
    StoreInstance.cleanStore();
}

function createSubscriberInfo(): void {
    const subscriberInfo: ISubscriberInfo = {
        id: globalHexId.getId(),
    };
    const StoreInstance = SubscriberStore.getInstance();
    StoreInstance.setInfo(subscriberInfo);
}

function formatSubDeviceInfo(info?: IDeviceAttributeAPI): IDeviceAttribute {
    const attributes = mapApi2UiField(info || {});
    delete attributes.band_details;
    const date = attributes?.created_at;

    const bandDetails = typeof info?.band_details === 'string' ? JSON.parse(info?.band_details) : info?.band_details;
    return {
        date,
        dateName: date ? dayjs(date).format(appConfig.formatDate) : '',
        name: `${attributes?.manufacturer ? attributes?.manufacturer + ' ' : ''}${attributes?.marketingName || ''}`,
        ...attributes,
        bandDetails,
    };
}

function setSubscriber({ resp, isError }: IGetApiResponse): void {
    if (!isError) {
        const typingResp = resp as ISubscriberAPI;
        const subAttribute = mapApi2UiField({ ...typingResp.subscriber }) as ISubscriberInfo;
        const deviceInfo = formatSubDeviceInfo(subAttribute?.deviceInfo);
        const info = {
            ...subAttribute,
            deviceInfo,
        } as ISubscriberInfo;
        const StoreInstance = SubscriberStore.getInstance();
        StoreInstance.setInfo(info);
    }
}

export async function getSubscriber(id?: string): Promise<boolean> {
    if (!id) {
        createSubscriberInfo();
        return true;
    } else {
        const apiResponse = await apiManager.getApi('GET_SUBSCRIBER_V2', { id: id });
        if (apiResponse.isError) {
            return false;
        } else {
            setSubscriber(apiResponse);
            return true;
        }
    }
}

export const getSubscriberStatusText = (s?: SubscriberType): string => {
    switch (s) {
        case SubscriberType.ACTIVE:
            return tI('ACTIVE');
        case SubscriberType.ACTIVE_THIS_MONTH:
            return tI('Active this month');
        case SubscriberType.LIVE:
            return tI('LIVE');
        case SubscriberType.PRE_ACTIVE:
            return tI('PRE ACTIVE');
        case SubscriberType.READY:
            return tI('READY');
        case SubscriberType.SUSPENDED:
            return tI('SUSPENDED');
        case SubscriberType.TERMINATED:
            return tI('TERMINATED');
        case SubscriberType.UNKNOWN:
            return tI('UNKNOWN');
        case SubscriberType.UNMANAGED:
            return tI('UNMANAGED');
        default:
            return tI('UNKNOWN');
    }
};
